import { addTaskActionService } from "./taskService";

export const completeTask = async ({ getToken, taskId, taskActionData }) => {
  console.log("completeTask", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const rescheduleTask = async ({ getToken, taskId, taskActionData }) => {
  console.log("rescheduleTask", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const markBlocked = async ({ getToken, taskId, taskActionData }) => {
  console.log("markBlocked", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const raisePriority = async ({ getToken, taskId, taskActionData }) => {
  console.log("raisePriority", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const dropPriority = async ({ getToken, taskId, taskActionData }) => {
  console.log("dropPriority", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const raiseQuestion = async ({ getToken, taskId, taskActionData }) => {
  console.log("raiseQuestion", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const raiseIssue = async ({ getToken, taskId, taskActionData }) => {
  console.log("raiseIssue", taskId);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

export const addToContext = async ({ getToken, taskId, taskActionData }) => {
  console.log("addToContext", taskId, taskActionData);
  
  await addTaskActionService(getToken, taskId, taskActionData);
  
  return;
};

/**
 * Get tasks to process
 * @param {Array} tasks - Array of tasks
 * @returns {Array} Array of tasks to process
 */
export const getRemainingTasksToProcess = (tasks) => {
  return tasks?.filter((task) => {
    const hasAssistantActions =
      task.actions?.filter((action) => action?.actor === "assistant").length > 0;

    return (
      !task.completed && !task.archived && task.status && !hasAssistantActions
    );
  });
};

/**
 * Get assistant actions
 * @param {Array} actions - Array of actions
 * @returns {Array} Array of assistant actions
 */
export const getAssistantActions = (actions) => {
  return actions
    ?.reduce((uniqueActions, action) => {
      if (
        !uniqueActions.some((uniqueAction) => uniqueAction.type === action.type)
      ) {
        uniqueActions.push(action);
      }
      return uniqueActions;
    }, [])
    .filter((action) => action.actor === "assistant");
};

/**
 * Get user actions
 * @param {Array} actions - Array of actions
 * @returns {Array} Array of user actions
 */
export const getUserActions = (actions) => {
  return actions
    ?.filter((action) => action.actor === "user")
    .reduce((uniqueActions, action) => {
      if (
        !uniqueActions.some((uniqueAction) => uniqueAction.type === action.type)
      ) {
        uniqueActions.push(action);
      }
      return uniqueActions;
    }, []);
};